import apiAuthClient from '@/services/apiAuthClient';
import apiClient from '@/services/apiClient';
import { defaultEoi } from '@/utilities/constants';

import errorHandler from '@/utilities/serverErrorHandler';

export const actions = {
  getEOI ({ commit, dispatch, getters, rootGetters }) {
      dispatch('ui/updateInterstitial', { isLoading: true, message: 'Getting your application...' }, { root: true });
      return apiAuthClient.get(`geticeoi/${process.env.VUE_APP_CONTRACT_ID_EOI}`, rootGetters['auth/getAccessToken']).then((res) => {
        if (res.status === 200) {
            // if EOI already exists, set the state to the response and flag that the eoi has been downloaded
            commit('UPDATE_EOI', res.data);
            dispatch('settings/updateDownloadedFlag', { flagName: 'eoiDownloaded', flagStatus: true }, { root: true });
            return true;
        }
      }).catch((err) => {
        return errorHandler('eoiErrors', err);
      }).finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
      });
  },
  createEOI ({ commit, getters, rootGetters, dispatch }) {
      dispatch('ui/updateInterstitial', { isLoading: true, message: 'Creating your application...' }, { root: true });
      const eoi = getters.getEOI;
      return apiAuthClient.post('AddICEOI', eoi, rootGetters['auth/getAccessToken']).then((res) => {
        if (res.status === 200) {
          commit('UPDATE_EOI', res.data);
          dispatch('settings/updateDownloadedFlag', { flagName: 'eoiDownloaded', flagStatus: true }, { root: true });
          return true;
        }
      }).catch((err) => {
        return errorHandler('eoiErrors', err);
      }).finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
      });
  },
  updateCurrentStep ({ commit }, payload) {
    commit('UPDATE_CURRENT_STEP', payload);
  },
  updateEOI ({ commit, getters, rootGetters, dispatch }, payload) {
    commit('UPDATE_EOI', payload);
    commit('UPDATE_ADDITIONAL_POSTCODE_FIELDS');

    const eoi = getters.getEOI;

    dispatch('ui/updateInterstitial', { isLoading: true, message: 'Updating your application...' }, { root: true });
    return apiAuthClient.put('UpdateICEOI', eoi, rootGetters['auth/getAccessToken']).then((res) => {
      if (res.status === 200) {
        return true;
      }
    }).catch((err) => {
      return errorHandler('eoiErrors', err, 'put');
    }).finally(() => {
      dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
    });
  },
  resetEOI ({ commit }) {
    commit('UPDATE_EOI', defaultEoi);
  },
  checkPostcodeEligibility ({ dispatch }, payload) {
    dispatch('ui/updateInterstitial', { isLoading: true, message: 'Checking your postcode...' }, { root: true });
    return apiClient.get(`investmentcentre/ispostcodeincontract?postcode=${payload}&contractid=${process.env.VUE_APP_CONTRACT_ID_EOI}`).then((res) => {
      if (res.status === 200) {
        return res.data;
      }
      return false;
    }).catch((err) => {
      console.log(err);
    }).finally(() => {
      dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
    });
  }
};
